import useFetch from "use-http";
import { MapAutonomousCommunity, MapMunicipality, MapProvince } from "./map-municipalities.service";
import { GeoJSON } from "highcharts";
import { getAbsoluteServerUrl } from "../config/config";
import { ADD_ALL_ID } from "../layouts/components/map-municipality-search/MapMunicipalitySearchForm";
import { errorDeRespuesta } from "./map-error.util";


export function buildGeojsonQueryParams(
  autonomousCommunities: MapAutonomousCommunity[],
  provinces: MapProvince[],
  municipalities: MapMunicipality[],
): string {
  const arrayToQueryParam = (name: string, list: { id: number }[]) =>
    list.map((it, index) => `${name}[${index}]=${it.id}`)
      .join('&')
  return [
    { name: 'autonomousCommunities', values: autonomousCommunities.filter(it => it.id !== ADD_ALL_ID) },
    { name: 'provinces', values: provinces },
    { name: 'municipalities', values: municipalities }
  ].filter(it => it.values.length).map(it => arrayToQueryParam(it.name, it.values)).join('&')
}

export function useGetGeojson({ autonomousCommunities, provinces, municipalities }:
  { autonomousCommunities: MapAutonomousCommunity[], provinces: MapProvince[], municipalities: MapMunicipality[] }) {
  const params = buildGeojsonQueryParams(autonomousCommunities, provinces, municipalities)
  return useFetch<GeoJSON>(getAbsoluteServerUrl(`/map/geojson?${params}`), { responseType: 'json' }, [])
}

export async function getGeojson({ autonomousCommunities, provinces, municipalities, signal }:
  { autonomousCommunities: MapAutonomousCommunity[], provinces: MapProvince[], municipalities: MapMunicipality[], signal?: AbortSignal }) {
  const params = buildGeojsonQueryParams(autonomousCommunities, provinces, municipalities)
  
  const response = await fetch(getAbsoluteServerUrl(`/map/geojson?${params}`), { signal });
  if (response.ok) {
    return (await response.json());
  }
  // el estado viaja en el error para que el mapa pueda avisar al usuario
  throw errorDeRespuesta(response.status);
}

export function useGetProvincesGeojson() {
  return useFetch<GeoJSON>(getAbsoluteServerUrl(`/map/provinces/geojson`), { responseType: 'json' }, [])
}

export function useGetMunicipalitiesGeojson() {
  return useFetch<GeoJSON>(getAbsoluteServerUrl(`/map/municipalities/geojson`), { responseType: 'json' }, [])
}
